var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Router } from '@angular/router';
import { of, empty } from 'rxjs';
import { ListingsService } from '../services/listings.service';
import { map, catchError } from 'rxjs/operators';
import { CommunicationService } from '../services/communication.service';
import { ListingCategory } from '../classes/enums';
import { Commercial, Luxury, Provinces } from '../app-config.constants';
import { PreRenderService } from '../services/pre-render.service';
import { UrlSanitizerService } from '../services/url-sanitizer.service';
import { UrlValidator } from './url-validator';
var MapCityResolver = /** @class */ (function (_super) {
    __extends(MapCityResolver, _super);
    function MapCityResolver(_listingsService, _communicationService, _preRenderService, _urlSanitizerService, _router) {
        var _this = _super.call(this, _urlSanitizerService, _router, _preRenderService) || this;
        _this._listingsService = _listingsService;
        _this._communicationService = _communicationService;
        _this._preRenderService = _preRenderService;
        _this._urlSanitizerService = _urlSanitizerService;
        _this._router = _router;
        return _this;
    }
    MapCityResolver.prototype.resolve = function (route, rstate) {
        var url = rstate.root.firstChild.url;
        var cityRegex = /(.+)-real-estate/;
        var province = url.length === 3 ? url[1].path : url[0].path;
        var category = '/';
        if (!this._preRenderService.isServerMode) {
            var referrer = document.referrer.split('/');
            category = referrer[referrer.length - 1];
        }
        var listingCategory = url.length === 3 ? this.getListingCategory(url[0].path) : this.getListingCategory(category);
        this._communicationService.setCurrentListingType(listingCategory);
        var cityMatches = cityRegex.exec(url.length === 3 ? url[2].path : url[1].path);
        var pageNumber = Number(route.queryParams.page) || 0; // For Pagination
        // We need to remember to decrement this value as pagination arrays start from 0
        if (pageNumber > 0)
            pageNumber--;
        if (cityMatches && cityMatches.length === 2) {
            var cityName_1 = cityMatches[1];
            // Reformat city name for front end after parsing from URL
            // Capitalize after space, hyphen, slash and replace hyphen with space
            cityName_1 = cityName_1.replace(/(^\w{1})|([\s-/]{1}\w{1})/g, function (match) { return match.toUpperCase(); });
            cityName_1 = cityName_1.replace(/-/g, ' ');
            var cityNameArr_1 = cityName_1.split(/[-,.']+/);
            if (!this.isValidUrl(url, route.queryParams))
                return empty();
            if (cityNameArr_1.length > 1 && cityNameArr_1.indexOf('') !== -1) {
                var fallbackUrl = url[0] + "/" + cityNameArr_1[0] + "-real-estate";
                this._router.navigate(["/" + fallbackUrl], { queryParams: route.queryParams });
                this._preRenderService.setPreRenderFlag(301, fallbackUrl, route.queryParams);
                return empty();
            }
            else if (cityNameArr_1.length > 1 && cityNameArr_1.indexOf('') === -1) {
                var found = false;
                var _loop_1 = function (i) {
                    if (Provinces.findIndex(function (g) { return (g.short.toLowerCase() === cityNameArr_1[i].toLowerCase() || g.medium.toLowerCase() === cityNameArr_1[i].toLowerCase() || g.long.toLowerCase() === cityNameArr_1[i].toLowerCase()); }) !== -1) {
                        found = true;
                    }
                };
                for (var i = 0; i < cityNameArr_1.length; i++) {
                    _loop_1(i);
                }
                if (found) {
                    var fallbackUrl = url[0] + "/" + cityNameArr_1[0] + "-real-estate";
                    this._router.navigate(["/" + fallbackUrl], { queryParams: route.queryParams });
                    this._preRenderService.setPreRenderFlag(301, fallbackUrl, route.queryParams);
                }
            }
            // Make a call to the listings to find the total hits before returning
            return this._listingsService.getListingsCount(false, province, cityName_1).pipe(map(function (hits) {
                return { city: cityName_1, province: province, totalListings: hits, pageNumber: pageNumber, category: listingCategory };
            }), 
            // FIXME: What should i do here
            catchError(function (err) {
                return of({ city: cityName_1, province: province, totalListings: 0, pageNumber: pageNumber, category: listingCategory });
            }));
        }
        else
            return of(null);
    };
    MapCityResolver.prototype.getListingCategory = function (listingCategory) {
        switch (listingCategory) {
            case Luxury:
                return ListingCategory.LUXURY;
            case Commercial:
                return ListingCategory.COMMERCIAL;
            default:
                return this._communicationService.listings.currentShownListingType.getValue();
        }
    };
    return MapCityResolver;
}(UrlValidator));
export { MapCityResolver };
